import {
  GroupMember,
  ProductBadge,
} from "~/common/Store/models/ProductListing";

type BadgeData = {
  unitOfMeasure: string;
  unitsPerPackaging: number;
};

export const getQuantityCountBadgeData = (
  unitsPerPackaging: number,
  productBadges: ProductBadge[],
  isGroupMaster: boolean,
  groupMembers: GroupMember[],
  unitOfMeasure: string,
): BadgeData | null => {
  if (
    unitsPerPackaging <= 1 ||
    !productBadges.some((badge) => badge.name === "Quantity Count")
  ) {
    return null;
  }

  if (isGroupMaster) {
    const haveSameUnitsPerPackaging =
      groupMembers.length > 0 &&
      groupMembers.every(
        (member) =>
          member.unitsPerPackaging === groupMembers[0]?.unitsPerPackaging,
      );
    return haveSameUnitsPerPackaging
      ? { unitOfMeasure, unitsPerPackaging }
      : null;
  }
  return { unitOfMeasure, unitsPerPackaging };
};
